module.exports = __webpack_public_path__ + "img/pose-2.ad412d7b.png";